var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.082,
    height: 19.082,
    viewBox: "0 0 19.082 19.082",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_106714",
    "data-name": "Group 106714",
    transform: "translate(-0.002 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49504",
    "data-name": "Path 49504",
    d: "M.561,10.1a.559.559,0,0,0,.559-.559,8.419,8.419,0,1,1,4.4,7.4l.7-.7a.559.559,0,0,0-.4-.954H3.148a.559.559,0,0,0-.559.559v2.675a.559.559,0,0,0,.954.4L4.7,17.762A9.542,9.542,0,0,0,16.29,2.794,9.541,9.541,0,0,0,0,9.541.559.559,0,0,0,.561,10.1Z",
    transform: "translate(0)",
    fill: "#284261"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49505",
    "data-name": "Path 49505",
    d: "M245.155,148.194h-3.034V145.16a.559.559,0,1,0-1.118,0v3.593a.559.559,0,0,0,.559.559h3.593a.559.559,0,0,0,0-1.118Z",
    transform: "translate(-232.019 -139.212)",
    fill: "#284261"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.bd6d1d95b02085d747985d4b64d72741.svg";
export { ForwardRef as ReactComponent };